module.exports = __webpack_public_path__ + "img/gb9116_19_d.prt.d0469142.jpg";